module.exports = __webpack_public_path__ + "img/49.5570bfde.jpg";